
import professional from './professional';
import dark from './dark';
import emoji from './emoji';
import glassmorphism from './glassmorphism';
import hologram from './hologram';
import synthwave from './synthwave';
import nature from './nature';
import cartoonish from './cartoonish';
import atlantic from './atlantic';
export const themes = {
  professional,
  dark,
  emoji,
  glassmorphism,
  hologram,
  synthwave,
  nature,
  cartoonish,
  atlantic
};

export const themesList = Object.values(themes);

// Helper function to get theme by ID
export const getThemeById = (id) => themes[id] || themes.professional;

// Get default theme
export const getDefaultTheme = () => themes.professional; 